import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { actionInterface, Concrete, modulInterface, roleMap, Settings, User } from '../interface/user';
import { UrlServices } from '../class/url-services';
import { checkExpiredWithHrs, cloneData, decryptData, encryptData, isEmptyObj } from '../class/utilityHelper';
import { RolePermissionService } from 'src/app/core/service/role-permission.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends RolePermissionService {
  dbName: string = environment.production ? 'live_dentalAdmin' : 'dev_dentalAdmin';
  private userBS: BehaviorSubject<User> = new BehaviorSubject<User>(({}) as User);
  private settingBS: BehaviorSubject<Settings> = new BehaviorSubject<Settings>(({}) as Settings);
  public currentUser: Observable<User>;
  public currentSetting: Observable<Settings>;
  constructor(private router: Router) {
    super();
    this.userBS = new BehaviorSubject<User>(({}) as User);
    this.currentUser = this.userBS.asObservable();
    this.currentSetting = this.settingBS.asObservable();
    this.setUserBS(this.getUser());
    this.setSettingBS(this.getCompanySetting())
  }

  public get currentUserValue(): User {
    return this.userBS.value;
  }
  public get currentSettingValue(): Settings {
    return this.settingBS.value;
  }

  setUserBS(user: User) {
    this.userBS.next(user)
    this.userRoleData = this.currentUserValue.permission || {} as roleMap;
  }
  setSettingBS(user: any) {
    this.settingBS.next(user)
  }

  getUser() {
    const res: any = localStorage.getItem(this.dbName);
    return decryptData(res) || {};
  }

  setApplicationUser(user: User) {
    this.clearLocalStorage();
    const f = `${user.fname} ${user.lname ? user.lname : ''}`;
    user.is_doctor = +user.is_doctor ? true : false;
    user.fullName = user.is_doctor && f.toLowerCase().search('dr.') == -1 ? `Dr. ${f}` : f;
    this.setUserBS(user);
    const userData = cloneData(encryptData(user));
    localStorage.setItem(this.dbName, userData);
  }

  setCompanySetting(data: any) {
    this.setSettingBS(data);
    const companyData = cloneData(encryptData(data));
    localStorage.setItem(this.dbName + '_company', companyData);

  }

  getCompanySetting() {
    const res: any = localStorage.getItem(this.dbName + '_company');
    return decryptData(res) || {};
  }

  loginStatus() {
    if (isEmptyObj(this.currentUserValue)) {
      this.setUserBS(this.getUser());
    }
    if (this.currentUserValue && this.currentUserValue.token) {
      return true;
    }
    return false;
  }

  getToken() {
    return this.currentUserValue.token || '';
  }

  clearLocalStorage() {
    localStorage.removeItem(this.dbName);
    localStorage.clear();
  }

  clearSubscribe() {
    this.userBS.next(({}) as User);
  }

  logout(returnUrl: any = '') {
    this.clearLocalStorage();
    // localStorage.removeItem(this.localStorageKey);
    this.clearSubscribe();
    // this.router.navigate([UrlServices.AUTH_PAGE.LOGIN_URL], { queryParams: { 'returnUrl': returnUrl ? returnUrl : this.router.url } });
    this.router.navigate([UrlServices.AUTH_PAGE.LOGIN_URL]);
  }

  isAllowable(mName: Concrete<keyof modulInterface>, aName: Concrete<keyof actionInterface>) {
    const res = this.checkPermission(mName, aName);
    if (!res) {
      this.redirectToDenied();
    }
    return res;
  }

  redirectToLogin() {
    this.router.navigate([UrlServices.AUTH_PAGE.LOGIN_URL]);
  }
  redirectToDashboard() {
    this.router.navigate([UrlServices.DASHBOARD_ROUTE]);
  }

  redirectToDenied() {
    this.router.navigate([UrlServices.ACCESS_DENIED_ROUTE]);
  }

  /* Plan Expiry */

  setPlanExpiredNotify() {
    const today = Date.now();
    localStorage.setItem(this.dbName + '_setNotify', cloneData(encryptData(today)))
  }

  getPlanExpiredNotify() {
    const res = localStorage.getItem(this.dbName + '_setNotify')
    return decryptData(res) || null
  }

  isPlanModalExpiryOpen() {
    const lastNotify = this.getPlanExpiredNotify()
    if (lastNotify) {
      const status = checkExpiredWithHrs(lastNotify)
      status && this.setPlanExpiredNotify()
      return status
    }
    this.setPlanExpiredNotify();
    return true;
  }


}

